module.exports = __webpack_public_path__ + "img/anchor-point.b234b48d.svg";